import { defineStore } from 'pinia';

export const contextMenuStore = defineStore('contextMenuStore', {
  state: () => {
    return {
      show: false,
      showX: 0,
      showY: 0,
      targetId: '',
    };
  },
  getters: {
    // 加入时间戳区分点击
    targetIdArray(): Array<string> {
      return this.targetId.split('_');
    },
  },
  actions: {
    changeShow(v: boolean): void {
      this.show = v;
    },
    changeXY(x: number, y: number): void {
      this.showX = x;
      this.showY = y;
    },
    setTargetId(id: string): void {
      if (id) {
        this.targetId = id + `_${new Date().getTime()}`;
      }
    },
  },
});
